<div class="emiplus_check" [ngClass]="{'emiplus_check--on': Actiavte, 'emiplus_check--off': !Actiavte}">

</div>
